import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5f689bab"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Lights up")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Set color for smart lamp via Robonomics Subscription - Decentrilized IoT cloud alternative. ")
const _hoisted_3 = { class: "tabs" }
const _hoisted_4 = { class: "tab" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Live ")
const _hoisted_6 = { class: "tab" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Custom ")
const _hoisted_8 = { class: "content" }

export function render(_ctx, _cache) {
  const _component_robo_card_label_section = _resolveComponent("robo-card-label-section")
  const _component_robo_card_label = _resolveComponent("robo-card-label")
  const _component_router_link = _resolveComponent("router-link")
  const _component_router_view = _resolveComponent("router-view")
  const _component_robo_card = _resolveComponent("robo-card")
  const _component_robo_grid_item = _resolveComponent("robo-grid-item")

  return (_openBlock(), _createBlock(_component_robo_grid_item, null, {
    default: _withCtx(() => [
      _createVNode(_component_robo_card, { allowExpand: "" }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_card_label, null, {
            default: _withCtx(() => [
              _createVNode(_component_robo_card_label_section, null, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_robo_card_label_section, { info: "" }, {
                default: _withCtx(() => [
                  _hoisted_2
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_router_link, {
                  to: "/lights-up",
                  exactActiveClass: "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_router_link, {
                  to: "/lights-up/custom",
                  exactActiveClass: "active"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_view)
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}